import Vue from 'vue';
import Ripple from 'primevue/ripple';

Vue.directive('ripple', Ripple);